import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const QuestionmarkIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="15"
      height="25"
      viewBox="0 0 15 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.000588185 6.36698C-0.00319817 6.45692 0.0113269 6.5467 0.0432697 6.63078C0.0752125 6.71487 0.123898 6.79148 0.186332 6.85592C0.248767 6.92035 0.323631 6.97125 0.406321 7.00547C0.489011 7.0397 0.577779 7.05652 0.667166 7.05492H2.94902C3.33072 7.05492 3.63496 6.7402 3.68475 6.35862C3.93368 4.53153 5.17833 3.2002 7.39657 3.2002C9.29397 3.2002 11.0309 4.15553 11.0309 6.45332C11.0309 8.22193 9.99651 9.03521 8.36187 10.2718C6.50042 11.6338 5.02621 13.2242 5.13131 15.806L5.13961 16.4104C5.14251 16.5932 5.21664 16.7674 5.34601 16.8956C5.47537 17.0238 5.64959 17.0956 5.83108 17.0956H8.07421C8.2576 17.0956 8.43348 17.0222 8.56316 16.8916C8.69284 16.7611 8.76569 16.584 8.76569 16.3993V16.1068C8.76569 14.1071 9.52077 13.525 11.5592 11.968C13.2437 10.6785 15 9.24688 15 6.24165C15 2.0332 11.4707 0 7.60678 0C4.1024 0 0.263348 1.64327 0.000588185 6.36698ZM4.30708 22.4181C4.30708 23.9026 5.48258 25 7.10062 25C8.78505 25 9.94396 23.9026 9.94396 22.4181C9.94396 20.8807 8.78228 19.8 7.09786 19.8C5.48258 19.8 4.30708 20.8807 4.30708 22.4181Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default QuestionmarkIcon;

QuestionmarkIcon.propTypes = customIconsPropTypes;
